import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Container } from '@mui/system';
import styled from 'styled-components';
import { StepBox } from './StepBox';

const HowCometeContainer = styled.section`
  padding: 2.5rem 0;
`;

export const HowCompete = () => {
  return (
    <HowCometeContainer>
      <Container>
        <Typography
          variant='h5'
          align='center'
          className='white--text'
          gutterBottom
        >
          Como concorrer?
        </Typography>
        <Grid container spacing={1}>
          <Grid item sm={4} xs={12}>
            <StepBox step='1'>A cada <span className='bold-text'>100 reais</span> em compras, além do Slime e do Bilhete da Sorte, você recebe um <span className='bold-text'>código para cadastrar neste site</span> e concorrer a 10 Nintendo Switch!</StepBox>
          </Grid>
          <Grid item sm={4} xs={12}>
            <StepBox step='2'>Clique em cadastre-se! Não esqueça de preencher todos os dados necessários para completar seu cadastro!</StepBox>
          </Grid>
          <Grid item sm={4} xs={12}>
            <StepBox step='3'>Resgate o código recebido durante sua compra. Quantos mais códigos resgatados, mais chances de ganhar! Aproveite!</StepBox>
          </Grid>
        </Grid>
      </Container>
    </HowCometeContainer>
  )
}
